module.exports = __webpack_public_path__ + "img/gif3.gif.bak.9ef4ce37.gif";